import { vatNumberValid } from "@/helpers/VatNumberValidator";

export var user = {
  data() {
    return {
      formValid: true,
      validatingLicensePlateLoader: false,
      validatingLicensePlateSuccessMessage: "",
      validatingLicensePlateErrorMessage: "",
      validatingLicensePlateLoadingMessage: "",
      validatingLicensePlateLoadingIcon: null,
      models: {
        first_name: null,
        last_name: null,
        city: null,
        zip_code: null,
        address: null,
        phone_number: null,
        gender: null,
        facebook_id: null,
        opt_in_promotion: !this.fieldEqualsDisplay("opt_in_promotion", "hidden")
          ? this.fieldEqualsDisplay("opt_in_promotion", "required")
          : null,
        opt_in_all_transactions: !this.fieldEqualsDisplay(
          "opt_in_all_transactions",
          "hidden"
        )
          ? this.fieldEqualsDisplay("opt_in_all_transactions", "required")
          : null,
        opt_in_topup: !this.fieldEqualsDisplay("opt_in_topup", "hidden")
          ? this.fieldEqualsDisplay("opt_in_topup", "required")
          : null,
        opt_in_newsletter: !this.fieldEqualsDisplay(
          "opt_in_newsletter",
          "hidden"
        )
          ? this.fieldEqualsDisplay("opt_in_newsletter", "required")
          : null,
        birth_date: null,
        invoice_email_recipient: "",
        is_b2b_customer: !this.fieldEqualsDisplay("b2b", "hidden")
          ? this.fieldEqualsDisplay("b2b", "required")
          : null,
        company_name: "",
        commercial_number: "",
        vat_number: "",
        expects_invoices: null,
        license_plate: {
          license_plate_country_code: null,
          license_plate: null
        }
      },
      licensePlateField: {},

      //data about selectable fields in spin
      possibleTextFields: {
        phone_number: {
          id: "phone_number",
          label: "label.phone_number",
          type: "tel",
          errorMessage: ""
        }
      },
      possibleCheckFields: [
        {
          id: "opt_in_promotion",
          label: "label.opt_in_promotion",
          value: "subscribed_for_vouchers"
        },
        {
          id: "opt_in_newsletter",
          label: "label.opt_in_newsletter",
          value: "subscribed_for_newsletter"
        },
        {
          id: "opt_in_all_transactions",
          label: "label.opt_in_all_transactions",
          value: "subscribed_for_sale_transactions"
        },
        {
          id: "opt_in_topup",
          label: "label.opt_in_topup",
          value: "subscribed_for_topup_transactions"
        }
      ],
      possibleGenderField: {
        id: "gender",
        choices: [
          { label: "label.male", value: "male" },
          { label: "label.female", value: "female" },
          { label: "label.other", value: "other" }
        ]
      },
      possibleDateField: {
        id: "birth_date",
        label: "label.birth_date",
        mask: "##-##-####"
      },

      possibleNameFields: [
        { id: "first_name", label: "label.first_name" },
        { id: "last_name", label: "label.last_name" }
      ],

      possibleAddressFields: [
        { id: "address", label: "label.address" },
        { id: "zip_code", label: "label.zip_code" },
        { id: "city", label: "label.city" }
      ],

      possibleSubscriptionFields: [
        {
          id: "subscription",
          label: "label.subscription"
        },
        {
          id: "invoice_email",
          label: "label.invoice_email_recipient"
        },
        {
          id: "expects_invoices",
          label: "label.expects_invoices"
        }
      ],

      rules: {
        license_plate: [v => !!v || this.$t("rules.license_plate_required")],
        first_name: [v => !!v || this.$t("rules.first_name_required")],
        last_name: [v => !!v || this.$t("rules.last_name_required")],
        address: [v => !!v || this.$t("rules.address_required")],
        phone_number: [v => !!v || this.$t("rules.phone_number_required")],
        gender: [v => !!v || this.$t("rules.gender_required")],
        birth_date: [
          v => !!v || this.$t("rules.birth_date_required"),
          v =>
            /^(?<Day>0[1-9]|[1-2][0-9]|3[0-1])-(?<Month>0[1-9]|1[0-2])-(?<Year>19\d{2}|20\d{2})$/.test(
              v
            ) || this.$t("rules.birth_date_valid")
        ],
        optional_birth_date: [
          v =>
            v.length === 0 ||
            /^(?<Day>0[1-9]|[1-2][0-9]|3[0-1])-(?<Month>0[1-9]|1[0-2])-(?<Year>19\d{2}|20\d{2})$/.test(
              v
            ) ||
            this.$t("rules.birth_date_valid")
        ],
        anonymous_card_barcode: [
          v => !!v || this.$t("rules.anonymous_card_barcode_required")
        ],
        invoice_email_recipient: [
          v =>
            !!v || this.$t("rules.invoice_email_recipient_frontend_required"),
          v => /.+@.+\..+/.test(v) || this.$t("rules.email_not_valid")
        ],
        email_validation: [
          v => !v || /.+@.+\..+/.test(v) || this.$t("rules.email_not_valid")
        ],
        expects_invoices: [
          v => !!v || this.$t("rules.expects_invoices_required")
        ],
        vat_number: [
          v => !!v || this.$t("rules.b2b_field_required"),
          v => vatNumberValid(v) || this.$t("rules.vat_number_invalid")
        ]
      }
    };
  },
  methods: {
    setFromModel(data, sanitized_model) {
      Object.keys(sanitized_model).forEach(key => {
        if (
          data.hasOwnProperty(key) &&
          !this.fieldEqualsDisplay(key, "hidden")
        ) {
          sanitized_model[key] = data[key];
        }
      });
      if (this.fieldEqualsDisplay("full_name", "hidden")) {
        sanitized_model.first_name = null;
        sanitized_model.last_name = null;
      }
      sanitized_model.facebook_id = data["id"];
    }
  },
  computed: {
    visibleCheckFields: function() {
      return this.possibleCheckFields.filter(
        field => !this.fieldEqualsDisplay(field.id, "hidden")
      );
    },
    visibleTextFields: function() {
      return Object.keys(this.possibleTextFields)
        .map(key => this.possibleTextFields[key])
        .filter(item => !this.fieldEqualsDisplay(item.id, "hidden"));
    }
  }
};
